import {z} from 'zod';

export const RequestStoreLocations = z.object({
  baseUrl: z.string().url(),
  bearerToken: z.string(),
});

export type RequestStoreLocations = z.infer<typeof RequestStoreLocations>;

export const getAuthenticationHeaders =  (barerToken: string): Headers => {
  const headers = new Headers();
  headers.append('Authorization', `Bearer ${barerToken}`);
  headers.append('Content-Type', 'application/json');
  return headers;
}

export const getAuthenticatedRequest = (api: RequestStoreLocations, route: string, query?: URLSearchParams, signal?: AbortSignal): Request => {
  const queryString:string = query?.toString() || '';
  if (queryString.length > 0) {
    route = `${route}?${queryString}`;
  }

  return new Request(new URL(route, api.baseUrl), {
    headers: getAuthenticationHeaders(api.bearerToken),
    signal,
  });
};
